import _asyncToGenerator from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["children", "onRedirectCallback", "onErrorCallback", "authEnv"];
var __jsx = React.createElement;
import _regeneratorRuntime from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Auth0Client } from '@auth0/auth0-spa-js';
import React from 'react';
import { toMatchingTld, SupportedTLD } from '@peloton/internationalize/models/locale';
import authClient, { AuthEnv } from './authClient';
import { getContainsLoginCookie } from './helpers'; // login errors from auth0 login error description when redirecting to app - see queryParams.error_description;

import { jsx as _jsx } from "react/jsx-runtime";
export var USER_EXISTS_LOGIN_ERROR_CODE = '10501';
export var GOOGLE_LOGIN_ERROR_CODE = '10502';
export var APPLE_LOGIN_ERROR_CODE = '10503';
export var USER_DOES_NOT_EXIST_LOGIN_ERROR_CODE = '20101';
export var loginErrors = new RegExp("".concat(USER_EXISTS_LOGIN_ERROR_CODE, "|").concat(GOOGLE_LOGIN_ERROR_CODE, "|").concat(APPLE_LOGIN_ERROR_CODE, "|").concat(USER_DOES_NOT_EXIST_LOGIN_ERROR_CODE));
var Auth0Context = /*#__PURE__*/React.createContext({
  isAuthenticated: false,
  isLoading: true,
  handleRedirectCallback: function handleRedirectCallback() {
    return Promise.resolve();
  },
  getAccessTokenSilently: function getAccessTokenSilently() {
    return Promise.resolve();
  },
  getIsAuthenticated: function getIsAuthenticated() {
    return Promise.resolve(false);
  },
  getIdTokenClaims: function getIdTokenClaims() {
    return Promise.resolve({
      __raw: '-1'
    });
  },
  loginWithRedirect: function loginWithRedirect() {
    return Promise.resolve();
  },
  logout: function logout() {
    return Promise.resolve();
  },
  checkSession: function checkSession() {
    return Promise.resolve({
      status: 400,
      data: null
    });
  },
  error: null
});
export var useOauth = function useOauth() {
  return React.useContext(Auth0Context);
};

var DEFAULT_REDIRECT_CALLBACK = function DEFAULT_REDIRECT_CALLBACK() {
  return window.history.replaceState({}, document.title, window.location.pathname);
};

export var getAuth0Client = function getAuth0Client(initOptions) {
  return new Auth0Client(_objectSpread({
    cacheLocation: 'localstorage',
    useRefreshTokens: true
  }, initOptions));
};
export var OAUTH_CLIENT_KEY = 'OAUTH_CLIENT_OPTS';
/*
 * the client id is set to localStorage for later access by the universal-logout page
 */

var useClientOptions = function useClientOptions(opts) {
  React.useEffect(function () {
    if (!!window) {
      try {
        window.localStorage.setItem(OAUTH_CLIENT_KEY, JSON.stringify({
          domain: opts.domain,
          client_id: opts.client_id
        }));
      } catch (e) {// catching in case stringify throws
      }
    }
  }, [opts.client_id, opts.domain]);
};

var OauthProvider = function OauthProvider(_ref) {
  var children = _ref.children,
      _ref$onRedirectCallba = _ref.onRedirectCallback,
      onRedirectCallback = _ref$onRedirectCallba === void 0 ? DEFAULT_REDIRECT_CALLBACK : _ref$onRedirectCallba,
      onErrorCallback = _ref.onErrorCallback,
      _ref$authEnv = _ref.authEnv,
      authEnv = _ref$authEnv === void 0 ? AuthEnv.Prod : _ref$authEnv,
      initOptions = _objectWithoutProperties(_ref, _excluded);

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isAuthenticated = _React$useState2[0],
      setIsAuthenticated = _React$useState2[1];

  var _React$useState3 = React.useState(undefined),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      auth0Client = _React$useState4[0],
      setAuth0 = _React$useState4[1];

  var _React$useState5 = React.useState(true),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      isLoading = _React$useState6[0],
      setLoading = _React$useState6[1];

  var _React$useState7 = React.useState(null),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      error = _React$useState8[0],
      setError = _React$useState8[1];

  var _React$useState9 = React.useState(''),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      errorDescription = _React$useState10[0],
      setErrorDescription = _React$useState10[1];

  useClientOptions(initOptions);
  React.useEffect(function () {
    var initAuth0 = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var auth0FromHook, _yield$auth0FromHook$, appState, authenticated;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                auth0FromHook = getAuth0Client(initOptions);

                if (!window.location.search.includes('code=')) {
                  _context.next = 14;
                  break;
                }

                _context.prev = 2;
                _context.next = 5;
                return auth0FromHook.handleRedirectCallback();

              case 5:
                _yield$auth0FromHook$ = _context.sent;
                appState = _yield$auth0FromHook$.appState;
                onRedirectCallback(appState);
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](2);
                setError(_context.t0);
                onErrorCallback === null || onErrorCallback === void 0 ? void 0 : onErrorCallback(_context.t0, 'handleRedirectCallback');

              case 14:
                _context.prev = 14;
                _context.next = 17;
                return auth0FromHook.isAuthenticated();

              case 17:
                authenticated = _context.sent;
                setIsAuthenticated(authenticated);
                _context.next = 25;
                break;

              case 21:
                _context.prev = 21;
                _context.t1 = _context["catch"](14);
                setError(_context.t1);
                onErrorCallback === null || onErrorCallback === void 0 ? void 0 : onErrorCallback(_context.t1, 'isAuthenticated');

              case 25:
                setAuth0(auth0FromHook);
                setLoading(false);

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 10], [14, 21]]);
      }));

      return function initAuth0() {
        return _ref2.apply(this, arguments);
      };
    }();

    initAuth0();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var handleRedirectCallback = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);

              if (!auth0Client) {
                _context2.next = 13;
                break;
              }

              _context2.prev = 2;
              _context2.next = 5;
              return auth0Client.handleRedirectCallback();

            case 5:
              setIsAuthenticated(true);
              _context2.next = 12;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](2);
              setError(_context2.t0);
              onErrorCallback === null || onErrorCallback === void 0 ? void 0 : onErrorCallback(_context2.t0, 'handleRedirectCallback');

            case 12:
              setLoading(false);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 8]]);
    }));

    return function handleRedirectCallback() {
      return _ref3.apply(this, arguments);
    };
  }();
  /**
   * checkSession returns a 200 status if session is valid
   */


  var checkSession = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _yield$auth0Client$ge;

      var TLD, api, token;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              TLD = toMatchingTld(window.location.hostname);
              api = authClient(authEnv, TLD);
              _context3.next = 4;
              return auth0Client === null || auth0Client === void 0 ? void 0 : auth0Client.getTokenSilently();

            case 4:
              _context3.t1 = _yield$auth0Client$ge = _context3.sent;
              _context3.t0 = _context3.t1 !== null;

              if (!_context3.t0) {
                _context3.next = 8;
                break;
              }

              _context3.t0 = _yield$auth0Client$ge !== void 0;

            case 8:
              if (!_context3.t0) {
                _context3.next = 12;
                break;
              }

              _context3.t2 = _yield$auth0Client$ge;
              _context3.next = 13;
              break;

            case 12:
              _context3.t2 = '';

            case 13:
              token = _context3.t2;
              return _context3.abrupt("return", api.get('/sso/check_session', {
                headers: {
                  Authorization: "Bearer ".concat(token)
                }
              }));

            case 15:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function checkSession() {
      return _ref4.apply(this, arguments);
    };
  }();

  var logout = function logout(opts) {
    var enableUniversalLogout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!auth0Client) {
      return Promise.resolve();
    }

    var tld = SupportedTLD.Com;
    var returnTo = "".concat(authEnv).concat(tld, "/sso/global_logout?continue=").concat(encodeURIComponent("".concat(opts === null || opts === void 0 ? void 0 : opts.returnTo)));

    try {
      return auth0Client === null || auth0Client === void 0 ? void 0 : auth0Client.logout(_objectSpread(_objectSpread({}, opts), opts !== null && opts !== void 0 && opts.returnTo && enableUniversalLogout ? {
        returnTo: returnTo
      } : {}));
    } catch (e) {
      onErrorCallback === null || onErrorCallback === void 0 ? void 0 : onErrorCallback(e, 'logout');
    }
  };

  var getIsAuthenticated = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var authenticated;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;

              if (!getContainsLoginCookie(authEnv)) {
                _context4.next = 6;
                break;
              }

              setIsAuthenticated(true);
              return _context4.abrupt("return", true);

            case 6:
              if (!auth0Client) {
                _context4.next = 14;
                break;
              }

              _context4.next = 9;
              return auth0Client.isAuthenticated();

            case 9:
              authenticated = _context4.sent;
              setIsAuthenticated(authenticated);
              return _context4.abrupt("return", authenticated);

            case 14:
              return _context4.abrupt("return", new Promise(function () {
                return null;
              }));

            case 15:
              _context4.next = 23;
              break;

            case 17:
              _context4.prev = 17;
              _context4.t0 = _context4["catch"](0);
              setError(_context4.t0);
              setIsAuthenticated(false);
              onErrorCallback === null || onErrorCallback === void 0 ? void 0 : onErrorCallback(_context4.t0, 'isAuthenticated');
              return _context4.abrupt("return", false);

            case 23:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 17]]);
    }));

    return function getIsAuthenticated() {
      return _ref5.apply(this, arguments);
    };
  }();

  var setLoginError = function setLoginError(errorCode) {
    setErrorDescription(errorCode);
  };

  var getLoginError = function getLoginError() {
    return errorDescription;
  };

  return /*#__PURE__*/_jsx(Auth0Context.Provider, {
    value: {
      error: error,
      isAuthenticated: isAuthenticated,
      isLoading: isLoading,
      checkSession: checkSession,
      logout: logout,
      handleRedirectCallback: handleRedirectCallback,
      loginWithRedirect: function loginWithRedirect() {
        var _ref6;

        return (_ref6 = auth0Client !== null && auth0Client !== void 0 ? auth0Client : getAuth0Client(initOptions)).loginWithRedirect.apply(_ref6, arguments);
      },
      getIsAuthenticated: getIsAuthenticated,
      getAccessTokenSilently: function getAccessTokenSilently() {
        return !!auth0Client ? auth0Client.getTokenSilently.apply(auth0Client, arguments) : Promise.resolve();
      },
      getIdTokenClaims: function getIdTokenClaims() {
        return !!auth0Client ? auth0Client.getIdTokenClaims.apply(auth0Client, arguments) : Promise.resolve({
          __raw: '-1'
        });
      },
      setLoginError: setLoginError,
      getLoginError: getLoginError
    },
    children: children
  });
};

export default OauthProvider;